import { memo, type ReactNode, Suspense, useMemo } from 'react';

import { Layout, Typography } from 'antd';
import cn from 'classnames';

import { useDesktopMediaQuery } from '@/shared/lib/hooks';
import { TourTriggerButtonLazy } from '@/shared/ui/tour-trigger-button';

import { usePageTitle } from '../../../lib/use-page-title';
import { AppMobileSider } from '../../sider/app-mobile-sider/app-mobile-sider';

import cls from './app-header.module.css';

interface AppHeaderProps {
    className?: string;
    rightContentSlot?: ReactNode;
}

export const AppHeader = memo((props: AppHeaderProps) => {
    const { className, rightContentSlot } = props;

    const title = usePageTitle();
    const isDesktop = useDesktopMediaQuery();

    const titleLevel = useMemo(() => (!isDesktop ? 5 : 4), [isDesktop]);

    return (
        <Layout.Header className={cn(cls.root, className)}>
            {!isDesktop && <AppMobileSider />}
            <div className={cls.titleContainer}>
                <Typography.Title level={titleLevel}>{title}</Typography.Title>
                {isDesktop && (
                    <Suspense fallback={null}>
                        <TourTriggerButtonLazy />
                    </Suspense>
                )}
            </div>
            {rightContentSlot && (
                <div className={cls.right}>{rightContentSlot}</div>
            )}
        </Layout.Header>
    );
});

AppHeader.displayName = 'AppHeader';
